import type {
  PlaceDetails,
  ResolvedPlace,
  Store,
} from "../../shared/types";

async function jsonFetch<T>(url: string, signal?: AbortSignal): Promise<T> {
  const res = await fetch(url, signal ? { signal } : undefined);
  if (!res.ok) {
    const body = await res.text().catch(() => "");
    throw new Error(`${res.status}: ${body || res.statusText}`);
  }
  return (await res.json()) as T;
}

export interface StoresResponse {
  stores: Store[];
  total: number;
}

export interface StoreMetaResponse {
  years: number[];
  areas: string[];
}

export interface StoresFilter {
  area?: string;
  year?: number;
  minSelections?: number;
}

export function fetchStores(params: StoresFilter): Promise<StoresResponse> {
  const qs = new URLSearchParams();
  if (params.area) qs.set("area", params.area);
  if (params.year !== undefined) qs.set("year", String(params.year));
  if (params.minSelections !== undefined)
    qs.set("minSelections", String(params.minSelections));
  const suffix = qs.toString() ? `?${qs.toString()}` : "";
  return jsonFetch<StoresResponse>(`/api/stores${suffix}`);
}

export function fetchStoreMeta(): Promise<StoreMetaResponse> {
  return jsonFetch<StoreMetaResponse>(`/api/stores/meta`);
}

export function fetchResolvedStore(
  id: string,
  signal?: AbortSignal,
): Promise<ResolvedPlace> {
  return jsonFetch<ResolvedPlace>(
    `/api/places/resolve?id=${encodeURIComponent(id)}`,
    signal,
  );
}

export function fetchPlaceDetails(placeId: string): Promise<PlaceDetails> {
  return jsonFetch<PlaceDetails>(
    `/api/places/${encodeURIComponent(placeId)}`,
  );
}

export function photoUrl(key: string): string {
  return `/api/places/photo?key=${encodeURIComponent(key)}`;
}
